import "es6-promise";
import { render } from 'react-dom';
import * as React from 'react';
import * as _ from 'lodash';
import PerformanceAddonsContainer from './performance-addons-container';
import { Store, createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import * as redux from 'redux';
import { PerformanceViewModel, IProductionModels, defaultProductionModels} from './classes';
import * as ActionTypes from './actions';
import { reduce } from './performance-addons-reducer';
import { } from './performance-addons';


export function performanceDispatch(): redux.Dispatch<Array<PerformanceViewModel>> {
    return _performanceState.dispatch;
}

/**
 * Exposes the current state of the directory redux store.
 */
export function performanceStore(): redux.Store<Array<PerformanceViewModel>> {
    return _performanceState;
}



createPerformanceStore(defaultProductionModels);
var appStore = performanceStore();

var bootStrapdata = (JSON.parse(JSON.stringify((window as any).bootStrappedData)) as IProductionModels);
performanceDispatch()(ActionTypes.initializePerformances(bootStrapdata));

var app = React.createElement(Provider, { store: appStore }, React.createElement(PerformanceAddonsContainer));
const appMount = document.getElementById('performance-addons');
render(app, appMount);


var _performanceState: redux.Store<any>;
var _defaultperformanceModel: IProductionModels;


export function createPerformanceStore(model: IProductionModels = defaultProductionModels) {

    _defaultperformanceModel = model;


    // Default initial state to the default directory model
    let initialState = defaultProductionModels;

    // Check the hash for an initial state
    if (window.location.hash) {
        const state = window.location.hash;

        if (Object.keys(state).some(_.identity)) {
            //initialState = deserializeProps(state);
        }
    }

    _performanceState = redux.createStore(reduce, initialState);
}